import ApiService from '../apiservice'

export default class ContaFinanceiraService extends ApiService {
  constructor() {
    super('/contaFinanceira')
  }

  cadastrar(conta) {
    return this.post('/',conta);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/consultar-por-codigo/${codigo}`);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }

  alterar(conta) {
    return this.put('/',conta);
  }

  listarAtivos(empresa) {
    return this.get(`/ativos/${empresa}`);
  }
}